import { EtymologyForm } from '@/features/factory/subfactories/EtymologyForm'

/** Sub-route /factory/etymology — wraps the Etymology form component. */
export function EtymologyPage() {
  return <EtymologyForm />
}
